import { Skeleton } from '@/components/ui/skeleton';

interface FullPageLoaderProps {
  /** Lido por leitor de tela; some visualmente para não competir com o conteúdo. */
  label?: string;
}

/**
 * Espera de tela cheia — usada enquanto a guarda de rota confirma a sessão.
 *
 * É um esqueleto do conteúdo, e não um spinner solto: a validação da sessão
 * acontece em toda navegação de entrada, e um giro no meio do vazio faz o app
 * parecer travado justamente no primeiro instante em que o cliente o vê.
 *
 * Os `Skeleton` internos vão com `aria-hidden`: cada um traz o próprio
 * `role="status"`, e uma dúzia deles faria o leitor de tela anunciar
 * "carregando" em série. O anúncio único fica no contêiner.
 */
export function FullPageLoader({ label = 'Carregando' }: FullPageLoaderProps) {
  return (
    <div
      className="flex min-h-dvh flex-col bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">{label}</span>
      <div className="border-b border-border" aria-hidden="true">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-6 md:px-10">
          <Skeleton className="h-4 w-32" aria-hidden="true" />
          <Skeleton className="h-9 w-9" aria-hidden="true" />
        </div>
      </div>
      <div
        className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-8 px-6 pt-12 md:px-10"
        aria-hidden="true"
      >
        <Skeleton className="h-8 w-64" aria-hidden="true" />
        <Skeleton className="h-5 w-full max-w-md" aria-hidden="true" />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Skeleton className="h-40 rounded-lg" aria-hidden="true" />
          <Skeleton className="h-40 rounded-lg" aria-hidden="true" />
          <Skeleton className="h-40 rounded-lg" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
